import { HttpClient } from '@adapters/HttpClient';

export interface ProductOption {
  id: string;
  name: string;
}

export class ProductsApiAdapter {
  constructor(private httpClient: HttpClient) {}

  async getAll(): Promise<ProductOption[]> {
    const raw = await this.httpClient.get<any>('/products', { fields: 'basic' });
    const list = Array.isArray(raw) ? raw : (raw.data ?? []);
    return list.map((product: any) => ({
      id: String(product.id),
      name: product.name || product.title,
    }));
  }
}
